import { supabase } from '@/lib/supabase'

// SSOT: app_settings['thermometer.weights']

export type ThermometerWeights = {
  version: number
  enabled: boolean
  weights: {
    // Bases (0..10)
    rsi_favorable: number
    ema_context: number
    fibo_zone_pos: number
    volume_correction: number

    // Ajustes direcionais (0..10 cada, pos/neg separados)
    rsi_alignment_pos: number
    rsi_alignment_neg: number
    ema_react_12_pos: number
    ema_react_12_neg: number
    ema_react_26_pos: number
    ema_react_26_neg: number

    // Fibo negativo e Pivot
    fibo_far_neg: number
    pivot_minor_pos: number
    pivot_minor_neg: number

    // Penalidade dura
    breakout_penalty: number
  }
}

export const THERMO_WEIGHTS_KEY = 'thermometer.weights'

export const DEFAULT_THERMOMETER_WEIGHTS: ThermometerWeights = {
  version: 1,
  enabled: true,
  weights: {
    // Replicar comportamento atual como padrão (pesos iguais p/ base)
    rsi_favorable: 10,
    ema_context: 10,
    fibo_zone_pos: 10,
    volume_correction: 10,

    // Ajustes mantendo a mesma influência do código atual quando =10
    rsi_alignment_pos: 10,
    rsi_alignment_neg: 10,
    ema_react_12_pos: 10,
    ema_react_12_neg: 10,
    ema_react_26_pos: 10,
    ema_react_26_neg: 10,

    fibo_far_neg: 0,
    pivot_minor_pos: 10,
    pivot_minor_neg: 0,

    breakout_penalty: 10,
  },
}

function parseWeights(v: any): ThermometerWeights {
  try {
    const obj = typeof v === 'string' ? JSON.parse(v) : v
    if (!obj || typeof obj !== 'object') return DEFAULT_THERMOMETER_WEIGHTS
    const merged: ThermometerWeights = {
      ...DEFAULT_THERMOMETER_WEIGHTS,
      ...obj,
      weights: { ...DEFAULT_THERMOMETER_WEIGHTS.weights, ...(obj as any).weights },
    }
    return merged
  } catch {
    return DEFAULT_THERMOMETER_WEIGHTS
  }
}

export async function getThermometerWeights(): Promise<ThermometerWeights> {
  const { data, error } = await supabase
    .from('app_settings')
    .select('value')
    .eq('key', THERMO_WEIGHTS_KEY)
    .maybeSingle()
  if (error || !data?.value) return DEFAULT_THERMOMETER_WEIGHTS
  return parseWeights(data.value)
}

export async function setThermometerWeights(payload: ThermometerWeights): Promise<void> {
  const safe: ThermometerWeights = parseWeights(payload as any)
  const { error } = await supabase
    .from('app_settings')
    .upsert({ key: THERMO_WEIGHTS_KEY, value: JSON.stringify(safe) }, { onConflict: 'key' })
  if (error) throw error
}

export async function resetThermometerWeights(): Promise<void> {
  await setThermometerWeights(DEFAULT_THERMOMETER_WEIGHTS)
}
